var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "  bin")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DC3545"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7 3.3L12.2 16.2C12.2 16.4 12 16.6 11.8 16.6L3.2 16.6C3 16.6 2.8 16.4 2.8 16.2L2.3 3.3C2.3 3 2 2.7 1.6 2.7 1.2 2.7 0.9 3 0.9 3.4L1.4 16.2C1.5 17.1 2.3 17.9 3.2 17.9L11.8 17.9C12.7 17.9 13.5 17.1 13.6 16.2L14.1 3.4C14.1 3 13.8 2.7 13.4 2.7 13 2.7 12.7 3 12.7 3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.9L7 14.7C7 14.9 7.2 15.2 7.5 15.2 7.8 15.2 8 14.9 8 14.7L8 5.9C8 5.6 7.8 5.4 7.5 5.4 7.2 5.4 7 5.6 7 5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.9L4.3 14.7C4.3 15 4.5 15.2 4.8 15.2 5.1 15.2 5.4 14.9 5.4 14.6L5.1 5.9C5.1 5.6 4.8 5.4 4.5 5.4 4.2 5.4 4 5.6 4 5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 5.9L9.6 14.6C9.6 14.9 9.9 15.2 10.2 15.2 10.5 15.2 10.7 15 10.7 14.7L11 5.9C11 5.6 10.8 5.4 10.5 5.4 10.2 5.4 9.9 5.6 9.9 5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 3.6L14.2 3.6C14.6 3.6 14.9 3.3 14.9 3 14.9 2.6 14.6 2.3 14.2 2.3L0.8 2.3C0.4 2.3 0.1 2.6 0.1 3 0.1 3.3 0.4 3.6 0.8 3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.7L5.7 1.8C5.8 1.6 6.1 1.4 6.3 1.4L8.7 1.4C8.9 1.4 9.2 1.6 9.3 1.8L9.5 2.7 10.8 2.4 10.5 1.5C10.3 0.7 9.5 0.1 8.7 0.1L6.3 0.1C5.5 0.1 4.7 0.7 4.5 1.5L4.2 2.4 5.5 2.7Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.f6a7e145.svg";
export { ForwardRef as ReactComponent };